export default __webpack_public_path__ + "static/media/volume-up.d8e0396d.svg";